import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';
const { EFPic } = createEFPic('/media/deltamax/pc/');

export default function Comp() {
    const { useLang, Link } = useGlobal();
    const { t } = useLang('delta_max_static');

    return (
        <div className={`${css.gsapdGroupA} gsapdGroupA`}>
            <div className="a-img-box">
                <div className="aBoxImg">
                    <EFPic name={['img_5.webp', 'img_5.png']} alt="" />
                </div>
            </div>
            <div className="a-msg-box">
                <div className="a-msg-box-in">
                    <div className="a-msg-box-a">
                        <div className="msg-line-a1">{t('AC Output')}</div>
                        <div className="msg-line-a2">{t('AC_Output_value')}</div>
                    </div>
                    <div className="a-msg-box-b">
                        <div className="msg-line-b1">
                            {t.rich('PA', {
                                line1: (child: any) => <>{child}</>,
                                line2: (child: any) => <span className="msg-b-fontsize1">{child}</span>,
                                line3: (child: any) => (
                                    <>
                                        <br />
                                        {child}
                                    </>
                                ),
                            })}
                        </div>
                        <div className="msg-line-b2">
                            {t.rich('PA_desc', {
                                line1: (text: any) => (
                                    <Link className="ef-link__page" href="/x-boost" newWin>
                                        {text}
                                    </Link>
                                ),
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
